var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3378_3970)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3378_3970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 8.55261V3.10461C24 1.41261 23.232 0.728607 21.324 0.728607H16.476C14.568 0.728607 13.8 1.41261 13.8 3.10461V8.54061C13.8 10.2446 14.568 10.9166 16.476 10.9166H21.324C23.232 10.9286 24 10.2446 24 8.55261Z",
    fill: "#486497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 22.0526V17.2046C24 15.2966 23.232 14.5286 21.324 14.5286H16.476C14.568 14.5286 13.8 15.2966 13.8 17.2046V22.0526C13.8 23.9606 14.568 24.7286 16.476 24.7286H21.324C23.232 24.7286 24 23.9606 24 22.0526Z",
    fill: "#00E1D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2 8.55261V3.10461C10.2 1.41261 9.432 0.728607 7.524 0.728607H2.676C0.768 0.728607 0 1.41261 0 3.10461V8.54061C0 10.2446 0.768 10.9166 2.676 10.9166H7.524C9.432 10.9286 10.2 10.2446 10.2 8.55261Z",
    fill: "#486497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2 22.0526V17.2046C10.2 15.2966 9.432 14.5286 7.524 14.5286H2.676C0.768 14.5286 0 15.2966 0 17.2046V22.0526C0 23.9606 0.768 24.7286 2.676 24.7286H7.524C9.432 24.7286 10.2 23.9606 10.2 22.0526Z",
    fill: "#486497"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3378_3970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.728607)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3378_3970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.728607)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboard);
export default __webpack_public_path__ + "static/media/icon-dashboard.f064d8f3982d2a98f0b375aa4c130e51.svg";
export { ForwardRef as ReactComponent };